import { render, staticRenderFns } from "./BookingSupportTicketForm.vue?vue&type=template&id=1bcdb5cd&scoped=true&"
import script from "./BookingSupportTicketForm.vue?vue&type=script&lang=js&"
export * from "./BookingSupportTicketForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcdb5cd",
  null
  
)

export default component.exports